<template>
  <div class="agenda-container flex align-center justify-between">
    <div
      class="box cs"
      v-for="(item, index) in list"
      :key="index"
      @click.stop="toOrder(item)"
    >
      <div class="type">{{ item.type }}</div>
      <div class="title flex">
        <div class="text ellipsis-2">{{ item.title }}&nbsp;</div>
        <div class="flex-sub" @click.stop="likeItem(item)">
          <img
            class="icon cs"
            :src="
              item.isLike
                ? require('../../assets/images/recommend/like.png')
                : require('../../assets/images/recommend/unlike.png')
            "
          />
        </div>
      </div>
      <div class="other flex flex-direction align-start">
        <div class="flex align-center">
          <img class="icon" src="../../assets/images/agenda/time.png" />
          <div class="text">{{ item.time }}</div>
        </div>
        <!--        <div class="flex align-center">-->
        <!--          <img class="icon" src="../../assets/images/agenda/address.png" />-->
        <!--          <div class="text">{{ item.address }}</div>-->
        <!--        </div>-->
      </div>
    </div>
    <!-- <unSignUp
      :tips="tips"
      :btn="btnText"
      ref="unSignUpDialog"
      @didClickunSignUp="didClickunSignUp"
    ></unSignUp> -->
  </div>
</template>

<script>
import moment from "moment";
import { $api } from "@/services/api";
import { $config } from "@/conf";
import _ from "lodash";
import { mapState } from "vuex";
import Cookie from "js-cookie";
import { hwAPI } from "@/services/modules/huawei";

export default {
  name: "agenda",
  data() {
    return {
      group: 0,
      agendaList: [],
      popShow: false,
      btnText: "好的",
      tips: "已取消收藏",
    };
  },
  components: {
    // unSignUp: () => import("../dialog/type/UnSignUp.vue"),
  },
  computed: mapState({
    userInfo: (state) => state.userInfo.info,
    tokenInfo: (state) => state.userInfo.token,
    isLogin: (state) => !!state.userInfo.token,
    AttendanceStatus: (state) => state.userInfo.AttendanceStatus,
    list: function () {
      // `this` 指向 vm 实例
      let list = this.agendaList;
      if (this.agendaList.length > 3) {
        list = this.agendaList.slice(this.group * 3, (this.group + 1) * 3);
      }
      return list;
    },
  }),
  mounted() {
    //未授权智能推荐时，不应该调智能推荐的接口
    let r = Cookie.get("accept_recommend");
    if (this.isLogin) {
      this.$api
        .GetRecommend()
        .then((res) => {
          if (res.result == 0) {
            this.acceptRecommend = res.content;
            Cookie.set("accept_recommend", res.content);
            if (this.acceptRecommend == 1) {
              this.getList();
            }
          }
        })
        .catch((err) => {
          this.acceptRecommend = 0;
        });
    } else {
      if (r == 1) {
        this.getList();
      }
    }

    //逻辑 用户点击 开始体验 页面无数据
    this.$bus.$on("reGetList", (res) => {
      //let r = Cookie.get("accept_recommend");
      if (res == 1) {
        this.getList();
      }
    });
  },
  methods: {
    //去登陆或报名
    didClickunSignUp() {
      this.$refs.unSignUpDialog.hideDialog();
      const { signOnlineUrl } = $config;
      let channel = Cookie.get("channel");
      window.location.href = `${signOnlineUrl}?channel=${
        channel || ""
      }&returnUrl=${encodeURIComponent(location.href)}`;
    },
    likeItem: _.debounce(function (item) {
      if (!this.isLogin) {
        this.tips = "您未登录，报名后有助于您使用更多功能";
        this.btnText = "去登录";
        this.$refs.unSignUpDialog.showDialog();
        return;
      }
      //判断是否报名
      if (this.AttendanceStatus == 3) {
        this.tips = "您未报名，报名后有助于您使用更多功能";
        this.btnText = "去报名";
        this.$refs.unSignUpDialog.showDialog();
        return;
      }
      hwAPI
        .favoriteAgenda({
          agendaId: item.agendaId,
          operation: !item.isLike ? 1 : 0,
          objectType: "agenda", //对象类型: agenda 议程；booth 展岛；
        })
        .then((res) => {
          //取消收藏埋码
          window._hw("send", "action", "mine_unsave_agenda", {
            agenda_name: item.title,
          });
          item.isLike = !item.isLike;
        })
        .catch((e) => {
          console.log(e);
        });
      //埋码
      window._hw("send", "action", "index_recommend_save_click", {
        agenda_name: item.title,
        hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系,
      });
    }, 200),
    toOrder(item) {
      //开发者大会推荐弹窗-点击推荐内容
      window._hw("send", "action", "index_recommend_content_click", {
        agenda_name: item.title,
        hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系,
      });
      this.$router.replace({
        path: "/agenda",
        query: {
          // ...this.$route.query,
          id: item.agendaId,
        },
      });
    },
    reset() {
      const group = Math.floor(Math.random() * (0 - 2) + 2);
      if (this.group === group) {
        this.reset();
      } else {
        this.group = group;
      }
    },
    async getList() {
      const myList = [];
      const recommendRes = await this.$api.getRecommendation({
        recommendType: "agenda",
      });
      let agendaRes;
      try {
        agendaRes = await this.$api.getMyAgendaList({
          objectType: "agenda",
        });
        agendaRes.data.forEach((item) => {
          myList.push(item.agendaId);
        });
      } catch (e) {
        console.log(e);
      }
      // const codelabsRes = await this.$api.getCodelabslist({
      //   field: [],
      // });

      // codelabsRes.data.items.forEach((item) => {
      //   myList.push(item.id);
      // });
      this.agendaList = recommendRes.data.agendaList.map((agenda) => {
        let type = "";
        try {
          type = JSON.parse(agenda.agendaType)[0];
        } catch (e) {
          console.log(e);
        }
        const agendaObj = {
          agendaId: agenda.agendaId,
          time:
            moment(agenda.startTime * 1000).format("HH:mm-") +
            moment(agenda.endTime * 1000).format("HH:mm"),
          type,
          title: agenda.agendaName,
          address: agenda.address,
          isLike: myList.indexOf(agenda.agendaId) >= 0,
        };
        return agendaObj;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 992px) {
  .agenda-container {
    width: 100%;
    height: 215px;
    overflow-x: hidden;

    .box {
      width: 300px;
      height: 190px;
      position: relative;
      background-image: url("../../assets/images/recommend/boxbg.png");
      background-repeat: no-repeat;
      background-position: 0 5px;
      background-size: 100% 100%;

      .type {
        width: 102px;
        height: 22px;
        position: absolute;
        top: 7px;
        right: 3px;
        font-size: 14px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #ffffff;
        line-height: 30px;
        text-align: center;
      }

      .title {
        width: 100%;
        height: 48px;
        position: absolute;
        top: 40px;
        left: 0;

        .text {
          width: 213px;
          height: 48px;
          margin-left: 31px;
          font-size: 16px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;

          color: #151e26;
          line-height: 24px;
        }

        .icon {
          flex-shrink: 0;
          width: 15px;
          height: 13px;
          margin-left: 22px;
          // margin-top: 7px;
        }
      }

      .other {
        width: auto;
        position: absolute;
        top: 130px;
        left: 30px;

        div:first-child {
          .icon {
            flex-shrink: 0;
            width: 15px;
            height: 15px;
            border-radius: 50%;
            margin-right: 7px;
          }

          .text {
            height: 30px;
            font-size: 16px;
            font-family: Microsoft YaHei-Light;
            font-weight: 400;

            color: #666666;
            line-height: 30px;
          }
        }

        div:last-child {
          .icon {
            flex-shrink: 0;
            width: 16px;
            height: 16px;
            margin-right: 7px;
          }

          .text {
            height: 30px;
            font-size: 16px;
            font-family: Microsoft YaHei-Light;
            font-weight: 400;

            color: #666666;
            line-height: 30px;
          }
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .agenda-container {
    width: 100%;
    overflow-x: hidden;
    height: 285px;
    flex-direction: row;
    flex-wrap: wrap;

    .box {
      width: 540px;
      height: 224px;
      margin-bottom: 26px;
      position: relative;
      background-image: url("../../assets/images/recommend/boxbg-wap.png");
      background-repeat: no-repeat;
      background-position: 0 0;
      background-size: 100% 100%;

      .type {
        width: 152px;
        height: 33px;
        position: absolute;
        top: 2px;
        right: 5px;
        text-align: center;
        font-size: 21px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #ffffff;
        line-height: 45px;
      }

      .title {
        width: 100%;
        height: 72px;
        position: absolute;
        top: 60px;
        left: 0;

        .text {
          width: 410px;
          height: 100%;
          margin-left: 47px;
          font-size: 24px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;

          color: #151e26;
          line-height: 36px;
        }

        .icon {
          flex-shrink: 0;
          width: 22px;
          height: 20px;
          margin-left: 34px;
          //margin-top: 10px;
        }
      }

      .other {
        width: auto;
        position: absolute;
        top: 150px;
        left: 48px;
        flex-direction: row;

        div:first-child {
          margin-right: 22px;

          .icon {
            flex-shrink: 0;
            width: 22px;
            height: 22px;
            border-radius: 50%;
            margin-right: 10px;
          }

          .text {
            height: 44px;
            font-size: 22px;
            font-family: Microsoft YaHei-Light;
            font-weight: 400;

            color: #666666;
            line-height: 43px;
          }
        }

        div:last-child {
          .icon {
            flex-shrink: 0;
            width: 22px;
            height: 22px;
            margin-right: 10px;
          }

          .text {
            height: 44px;
            font-size: 22px;
            font-family: Microsoft YaHei-Light;
            font-weight: 400;

            color: #666666;
            line-height: 43px;
          }
        }
      }
    }
  }
}
</style>
